<template>
   <div>
        <div class="table-wrapper on-991" v-if="$i18n.locale=='en'">
            <div class="custom-table balance-table ">
                <div class="trow dark-gray">
                    <div data-width='70%'></div>
                    <div data-width='15%' class="skyBlue bolder ligest-gray">2020</div>
                    <div data-width='15%' class="bolder white">2019</div>
                </div>
                <div class="trow lGray">
                    <div data-width='70%'></div>
                    <div data-width='30%' class="bold white center">KD ’000</div>
                </div>
                <div class="trow b-top ">
                    <div data-width='70%' class="font">Cash on hand and at banks</div>
                    <div data-width='15%' class="font light-gray">313,021</div>
                    <div data-width='15%' class="font">132,576</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Short-term deposits with banks</div>
                    <div data-width='15%' class="font light-gray">97,923</div>
                    <div data-width='15%' class="font">180,931</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Government certificates of deposits held by subsidiaries</div>
                    <div data-width='15%' class="font light-gray"> 89</div>
                    <div data-width='15%' class="font">108</div>
                </div>
                <div class="trow dark-gray">
                    <div data-width='70%' class=""></div>
                    <div data-width='15%' class="font text-white ">411,033</div>
                    <div data-width='15%' class="font text-white">313,615</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Expected credit loss</div>
                    <div data-width='15%' class="font light-gray"> (17,973) </div>
                    <div data-width='15%' class="font">(16,630)</div>
                </div>
                <div class="trow dark-gray ">
                    <div data-width='70%' class=""></div>
                    <div data-width='15%' class="font text-white "> 393,060</div>
                    <div data-width='15%' class="font text-white">296,985</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Cash at bank under lien</div>
                    <div data-width='15%' class="font light-gray"> (29,405)</div>
                    <div data-width='15%' class="font">(36,140)</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">Maturities exceeding three months held by subsidiary</div>
                    <div data-width='15%' class="font light-gray">(89)</div>
                    <div data-width='15%' class="font">(108)</div>
                </div>
                <div class="trow dark-gray ">
                    <div data-width='70%' class=""></div>
                    <div data-width='15%' class=" bold white ">363,566</div>
                    <div data-width='15%' class=" bold white">260,737</div>
                </div>
            </div>
        </div>

        <!-- Arabic -->

        <div class="table-wrapper on-991" v-if="$i18n.locale=='ar'">
            <div class="custom-table balance-table ">
                <div class="trow dark-gray">
                    <div data-width='70%'></div>
                    <div data-width='15%' class="skyBlue bolder ligest-gray">2020</div>
                    <div data-width='15%' class="bolder white">2019</div>
                </div>
                <div class="trow lGray">
                    <div data-width='70%'></div>
                    <div data-width='30%' class="bold white center">ألف دينار كويتي</div>
                </div>
                <div class="trow b-top ">
                    <div data-width='70%' class="font">نقد بالصندوق ولدى البنوك</div>
                    <div data-width='15%' class="font light-gray">313,021</div>
                    <div data-width='15%' class="font">132,576</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">ودائع قصيرة الأجل لدى البنوك</div>
                    <div data-width='15%' class="font light-gray">97,923</div>
                    <div data-width='15%' class="font">180,931</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">شهادات إيداع حكومية محتفظ بها من قبل شركات تابعة</div>
                    <div data-width='15%' class="font light-gray"> 89</div>
                    <div data-width='15%' class="font">108</div>
                </div>
                <div class="trow dark-gray">
                    <div data-width='70%' class=""></div>
                    <div data-width='15%' class="font text-white ">411,033</div>
                    <div data-width='15%' class="font text-white">313,615</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">الخسارة الائتمانية المتوقعة</div>
                    <div data-width='15%' class="font light-gray"> (17,973) </div>
                    <div data-width='15%' class="font">(16,630)</div>
                </div>
                <div class="trow dark-gray ">
                    <div data-width='70%' class=""></div>
                    <div data-width='15%' class="font text-white "> 393,060</div>
                    <div data-width='15%' class="font text-white">296,985</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">نقد محتجز لدى بنوك</div>
                    <div data-width='15%' class="font light-gray"> (29,405)</div>
                    <div data-width='15%' class="font">(36,140)</div>
                </div>
                <div class="trow ">
                    <div data-width='70%' class="font">شهادات إيداع حكومية محتفظ بها من قبل شركات تابعة بآجال استحقاق تتجاوز ثلاثة أشهر</div>
                    <div data-width='15%' class="font light-gray">(89)</div>
                    <div data-width='15%' class="font">(108)</div>
                </div>
                <div class="trow dark-gray ">
                    <div data-width='70%' class=""></div>
                    <div data-width='15%' class=" bold white ">363,566</div>
                    <div data-width='15%' class=" bold white">260,737</div>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
export default {

}
</script>

<style>

</style>